import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Users from "./components/user/Users";
import UserDetails from "./components/pages/UserDetails";
import About from "./components/pages/About";
import "./App.css";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (typeof window !== "undefined") {
      const savedTheme = localStorage.getItem("githubhunt-theme");
      if (savedTheme) {
        return savedTheme === "dark";
      }
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
    return false;
  });

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      isDarkMode ? "dark" : "light"
    );
    localStorage.setItem("githubhunt-theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  return (
    <div className="app-shell">
      <Router>
        <Navbar
          isDarkMode={isDarkMode}
          onToggleTheme={() => setIsDarkMode((value) => !value)}
        />
        <main className="page-shell">
          <Switch>
            <Route exact path="/" component={Users} />
            <Route exact path="/about" component={About} />
            <Route exact path="/:uid" component={UserDetails} />
          </Switch>
        </main>
        <footer className="site-footer">
          <p>Built by Lakshay Dhoundiyal</p>
          <div className="footer-links">
            <a href="https://github.com/LakshayD02" target="_blank" rel="noopener noreferrer">
              GitHub
            </a>
            <a
              href="https://github.com/LakshayD02/GitHunt_Github_Finder"
              target="_blank"
              rel="noopener noreferrer"
            >
              Project Repository
            </a>
          </div>
        </footer>
      </Router>
    </div>
  );
}

export default App;
